import { GzRmScannedResourcesWidgetWebComponent } from './component/GzRmScannedResourcesWidgetWebComponent';

export { GzRmScannedResourcesWidgetWebComponent };
